module.exports = __webpack_public_path__ + "img/accounts-api.8dcf857c.png";